import React from "react";

interface IProps {
	width?: number;
	height?: number;
	color?: string;
}

export const IconBurgerMenu: React.FC<IProps> = ({color, ...rest}) => (
	<svg viewBox="0 0 24 24" fill="none" {...rest}>
		<path d="M1.2 2.74286H22.8V4.8H1.2V2.74286Z" fill={color} />
		<path d="M1.2 10.9714H22.8V13.0286H1.2V10.9714Z" fill={color} />
		<path d="M22.8 19.2H1.2V21.2571H22.8V19.2Z" fill={color} />
	</svg>
);

IconBurgerMenu.defaultProps = {
	width: 24,
	height: 24,
	color: "currentColor",
};
